var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RoleEnum } from "../types/RoleEnum";
export var prefillGuarantorRoles = function (guarantors) {
    if (!(guarantors === null || guarantors === void 0 ? void 0 : guarantors.length)) {
        return guarantors;
    }
    var someGuarantorHasRole = guarantors.some(function (guarantor) { return guarantor.roles && guarantor.roles.length > 0; });
    if (someGuarantorHasRole) {
        return guarantors;
    }
    return guarantors.map(function (guarantor, index) {
        return index === 0
            ? __assign(__assign({}, guarantor), { roles: [RoleEnum.PUBLISHER_ADMIN] }) : guarantor;
    });
};
